'use strict';

angular.module('atex.dam').factory('DamDistributionListService', [
  'ContentService',
  function(
    ContentService
  ) {

    return {
      getDistributionLists: function (_options) {
        var options = _.extend({}, {
          skipHiddenLists: true
        }, _options);
        return ContentService.getContent({id: 'externalid/dam.distributionlist.conf'}).then(function (content) {
          var groups = [];
          var users = [];
          var distributionConf = atex.dam.AngularUtils.cleanUpJson(atex.onecms.ObjectUtils.getByPath(content.data.aspects, 'contentData/data') || {});
          if (distributionConf && distributionConf.lists) {
            var data = distributionConf.lists;
            for (var idx = 0; idx < data.length; idx++) {
              var distList = data[idx];
              var k = distList.name;

              // skip distribution lists which starts with '_'

              if (options.skipHiddenLists && k.startsWith('_')) {
                continue;
              }

              // only allow email distribution lists.

              if (options.type && distList.type !== options.type) {
                continue;
              }

              var v = distList.contents;
              groups.push(k);
              users = users.concat(v);
            }
            users = _.uniq(users);
          }
          return { groups: groups, users: users };
        });
      }
    };
  }
]);
